"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PinterestIcon = function (props) {
    return (react_1.default.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24" }, props),
        react_1.default.createElement("path", { d: "M12 0C5.373 0 0 5.373 0 12c0 4.914 2.955 9.135 7.183 10.99-.034-.837-.006-1.843.209-2.755l1.544-6.538s-.383-.767-.383-1.9c0-1.777 1.03-3.105 2.314-3.105 1.091 0 1.619.82 1.619 1.801 0 1.097-.7 2.739-1.06 4.259-.3 1.273.638 2.31 1.894 2.31 2.274 0 3.805-2.92 3.805-6.38 0-2.63-1.771-4.598-4.993-4.598-3.64 0-5.908 2.715-5.908 5.747 0 1.045.308 1.783.79 2.354.223.262.254.367.173.668l-.244.963c-.08.304-.326.413-.6.3-1.678-.684-2.458-2.52-2.458-4.584 0-3.408 2.874-7.496 8.576-7.496 4.582 0 7.597 3.315 7.597 6.874 0 4.708-2.617 8.224-6.475 8.224-1.295 0-2.514-.7-2.932-1.495 0 0-.696 2.764-.844 3.298-.254.926-.752 1.85-1.208 2.57 1.08.32 2.22.493 3.401.493 6.627 0 12-5.373 12-12S18.627 0 12 0" })));
};
exports.default = PinterestIcon;
